module.exports = __webpack_public_path__ + "img/activeTitle1.e7036bab.png";